<template>
  <div class="staff-basic">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/yuangong/simple"
      @before-fetch="beforeFetch"
    >
      <email-table-column slot="email"></email-table-column>
      <el-table-column slot="bumen" show-overflow-tooltip label="公司">
        <template v-slot="{row}">
          <span>{{row | bumen}}</span>
        </template>
      </el-table-column>
      <photo-table-column slot="photo"></photo-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import DepartmentCascade from '@/components/service/department-cascade'
import mixin from '@/mixins'

export default {
  name: 'staff-basic',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      fields: [
        {
          prop: 'name',
          placeholder: '姓名/工号',
          clearable: true
        },
        {
          prop: 'department',
          placeholder: '公司',
          component: DepartmentCascade,
          value: []
        }
      ],
      columns: [
        { prop: 'id', label: '工号', width: 100 },
        { prop: 'name', label: '姓名', width: 100 },
        { slot: 'bumen' },
        { prop: 'mobile', label: '手机', width: 140 },
        { slot: 'email' },
        { prop: 'seat', label: '座位', width: 80 },
        { slot: 'photo' }
      ]
    }
  },
  methods: {
    beforeFetch (params) {
      [ (params.jiagou_first), (params.jiagou_second), (params.jiagou_third), (params.jiagou_forth) ] = params.department
      params.gong_id = params.name
      delete params.department
    }
  }
}
</script>

<style lang="scss">
</style>
